// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2ff6fd25f9317c4b0215f50180cc9fc4830103f8.chunk.js";
};